export default __webpack_public_path__ + "static/media/image.concode-technologies.832ec6ac.png";